/**
 * Which voice a call uses (RFC 0307 S5).
 *
 * One default, OpenAI Realtime, and no picker in the composer: the Design
 * says there is one voice. The setting exists so the second adapter can be
 * run and compared, by setting `voice.provider` to `elevenlabs`.
 */

import { elevenlabsProvider } from './elevenlabsAgent'
import { openaiRealtimeProvider } from './openaiRealtime'
import type { VoiceProvider, VoiceProviderId } from './types'

const KEY = 'voice.provider'

export function voiceProviderId(): VoiceProviderId {
  try {
    return localStorage.getItem(KEY) === 'elevenlabs' ? 'elevenlabs' : 'openai'
  } catch {
    return 'openai'
  }
}

export function voiceProviderFor(id: VoiceProviderId): VoiceProvider {
  return id === 'elevenlabs' ? elevenlabsProvider() : openaiRealtimeProvider()
}

/** The provider as chosen when a call connects, not when the page loaded. */
export function chosenVoiceProvider(): VoiceProvider {
  return {
    connect: (opts) => voiceProviderFor(voiceProviderId()).connect(opts),
  }
}
